// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===============================
   🌍 Variablen
================================= */
:root {
  --primary: #1F7FA6;
  --primary-dark: #175f7a;
  --secondary: #1F7FA6;

  --bg: #f5f7fa;
  --card-bg: #ffffff;

  --text-main: #1f2937;
  --text-muted: #6c757d;

  --border-light: #e9ecef;

  --radius: 10px;
  --shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
}

body.dark {
  --primary: #3aa0c8;
  --primary-dark: #1F7FA6;
  --secondary: #3aa0c8;

  --bg: #0f1117;
  --card-bg: #1a1d27;

  --text-main: #f0f4f8;
  --text-muted: #c8d4e0;

  --border-light: #2d3148;

  --shadow: 0 4px 14px rgba(0, 0, 0, 0.4);
}

/* ===============================
   🌍 Grundlayout
================================= */
body {
  margin: 0;
  background: var(--bg);
  font-family: 'Poppins', Arial, sans-serif;
  color: var(--text-main);
  transition: background 0.2s, color 0.2s;
}

body.dark .card {
  background: linear-gradient(135deg, #1e2130 0%, #161926 100%);
  border-color: var(--border-light);
}

body.dark .import-card {
  background: linear-gradient(135deg, #1e2130 0%, #161926 100%);
}

body.dark input:not([type="radio"]):not([type="checkbox"]),
body.dark select,
body.dark textarea {
  background: #0f1117;
  color: var(--text-main);
  border-color: var(--border-light);
}

body.dark .user-list-item,
body.dark .maintenance-row--confirm td,
body.dark .image-mgmt-row {
  background: #0f1117;
}

body.dark .tab-nav {
  border-bottom-color: var(--border-light);
}

body.dark .file-upload-btn {
  background: #1a1d27;
}

body.dark .login-box,
body.dark .dialog-box {
  background: #1a1d27;
}

body.dark .login-overlay {
  background: #0f1117;
}

body.dark .flop-title,
body.dark .region-name,
body.dark .category-name {
  color: var(--text-main);
}

body.dark .flop-category,
body.dark .region-sub,
body.dark .category-sub,
body.dark .flop-meta,
body.dark .label-muted {
  color: var(--text-muted);
}

body.dark .flop-item,
body.dark .region-item,
body.dark .category-item {
  border-bottom-color: var(--border-light);
}

body.dark .category-count {
  background: #1e3a4a;
  color: #3aa0c8;
}

body.dark .progress-bar {
  background: #2d3148;
}

body.dark .top-bar label,
body.dark .section-label,
body.dark .card p {
  color: var(--text-muted);
}

/* Datumfelder: Textfarbe auf Placeholder-Grau, Kalender-Icon hell */
body.dark .date-range input[type="date"] {
  color: var(--text-muted) !important;
  color-scheme: dark;
}

/* Salon-Suchergebnisse Dark Mode */
body.dark .salon-result-item {
  background: #1e2130;
}
body.dark .salon-result-item--expanded {
  background: #252839;
}
body.dark .salon-name {
  color: var(--text-main);
}
body.dark .salon-closing,
body.dark .salon-expand-toggle {
  color: var(--text-muted);
}
body.dark .salon-detail {
  background: #252839;
  color: var(--text-muted);
}


.card .search-clear-btn {
  background: #fff;
  border: 2px solid var(--secondary);
  color: var(--secondary);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 5px 20px;
  border-radius: 6px;
  transition: all 0.2s ease;
  white-space: nowrap;
  margin-top: 0;
}
.card .search-clear-btn:hover {
  background: var(--primary-dark);
  border-color: var(--primary-dark);
  color: #fff;
}
body.dark .card .search-clear-btn { background: #1a1d27; }

/* react-select Dark Mode */
body.dark .rs__control {
  background-color: #1e2130;
  border-color: var(--border-light);
  color: var(--text-main);
}
body.dark .rs__control:hover { border-color: var(--primary); }
body.dark .rs__control--is-focused { border-color: var(--primary); box-shadow: 0 0 0 1px var(--primary); }
body.dark .rs__menu { background-color: #1e2130; border: 1px solid var(--border-light); }
body.dark .rs__option { background-color: #1e2130; color: var(--text-main); }
body.dark .rs__option--is-focused { background-color: #2d3148; }
body.dark .rs__option--is-selected { background-color: var(--primary); color: #fff; }
body.dark .rs__single-value { color: var(--text-main); }
body.dark .rs__placeholder { color: var(--text-muted); }
body.dark .rs__input-container { color: var(--text-main); }
body.dark .rs__indicator-separator { background-color: var(--border-light); }
body.dark .rs__dropdown-indicator { color: var(--text-muted); }
body.dark .rs__clear-indicator { color: var(--text-muted); }
body.dark .rs__multi-value { background-color: #2d3148; }
body.dark .rs__multi-value__label { color: var(--text-main); }

.app {
  padding: 30px;
  max-width: 1100px;
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1 1;
}

h1 {
  margin-bottom: 20px;
  text-align: center;
}

/* ===============================
   📦 Grid Layout
================================= */
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
  margin-bottom: 30px;
}

/* ===============================
   🪟 Karten
================================= */
.card {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 1px dashed #adb5bd;
  border-radius: var(--radius);
  padding: 24px 26px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.card h2 {
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.card p {
  margin: 12px 0 6px;
  font-weight: 500;
}

.card ul {
  padding-left: 18px;
  margin: 0;
}

.card li {
  margin-bottom: 6px;
}

.card label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* ===============================
   📝 Formular
================================= */
.full-width {
  grid-column: span 3;
}

.entry-form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px 24px;
  align-items: end;
  margin-bottom: 16px;
}

.form-field p,
.form-field > label:not(.radio-item) {
  margin: 0 0 7px;
  font-size: 13px;
  font-weight: 600;
  display: block;
}

/* Inputs */
.card input:not([type="radio"]):not([type="checkbox"]),
.card select {
  width: 100%;
  max-width: 100%;
  padding: 7px 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
  box-sizing: border-box;
}

/* Fokus */
.card input:not([type="radio"]):not([type="checkbox"]):focus,
.card select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(46, 125, 50, 0.15);
}

/* Section label */
.section-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-main);
  margin: 16px 0 8px;
}

/* Primär-Button */
.btn-primary {
  padding: 9px 20px;
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 0;
}
.btn-primary:hover { background: var(--primary-dark); }
.btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }

/* Sekundär-Button */
.btn-secondary {
  padding: 9px 20px;
  background: #fff;
  color: var(--secondary);
  border: 2px solid var(--secondary);
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 0;
}
.btn-secondary:hover { background: var(--secondary); color: #fff; }

/* ===============================
   🔘 Radio Buttons
================================= */
.radio-group {
  display: flex;
  gap: 24px;
  margin-top: 10px;
  flex-wrap: wrap;
}

.radio-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.radio-item input {
  width: auto;
  margin: 0;
}

/* ===============================
   🔘 Buttons
================================= */
.card button {
  margin-top: 15px;
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  background-color: var(--primary);
  color: white;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  transition: background 0.2s ease;
}

.card button:hover {
  background-color: var(--primary-dark);
}

.button-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid var(--border-light);
}

/* ===============================
   📊 Progress Bars
================================= */
.progress-bar {
  width: 100%;
  height: 10px;
  background: #e0e0e0;
  border-radius: 5px;
  margin-bottom: 10px;
  overflow: hidden;
}

.progress {
  height: 100%;
  background: var(--primary);
  transition: width 0.6s ease;
}

/* ===============================
   📊 Kategorien
================================= */
.category-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.category-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.category-item:last-child {
  border-bottom: none;
}

.category-count {
  font-weight: 600;
  background: #e8f5e9;
  color: var(--primary);
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 13px;
}

/* ===============================
   📂 Import Card
================================= */
.import-card {
  padding: 20px 24px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 1px dashed #adb5bd;
  display: flex;
  flex-direction: column;
}

.import-row {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  gap: 12px;
}

.import-action {
  margin-top: auto;
  padding-top: 16px;
  display: flex;
  justify-content: center;
}

.file-upload-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #fff;
  border: 2px solid var(--secondary);
  border-radius: 8px;
  color: var(--secondary);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.file-upload-btn:hover {
  background: var(--secondary);
  color: #fff;
}

.file-upload-btn input[type="file"] {
  display: none;
}

/* ===============================
   📱 Responsive
================================= */

/* ===============================
   🖼 Bild-Modal
================================= */
.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: modal-fade-in 0.2s ease;
}

@keyframes modal-fade-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.image-modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 90vw;
  max-height: 90vh;
  animation: modal-slide-up 0.22s ease;
}

@keyframes modal-slide-up {
  from { transform: translateY(24px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}

.image-modal-content img {
  max-width: 100%;
  max-height: 78vh;
  border-radius: 10px 10px 0 0;
  display: block;
  box-shadow: 0 20px 60px rgba(0,0,0,0.6);
}

.modal-close {
  position: absolute;
  top: -14px;
  right: -14px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fff;
  border: none;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  color: #333;
  z-index: 1;
  transition: background 0.15s;
}

.modal-close:hover {
  background: #f0f0f0;
}

.modal-info {
  width: 100%;
  background: #1a1a2e;
  border-radius: 0 0 10px 10px;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.6);
}

.modal-title {
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.modal-meta {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.modal-badge {
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 12px;
  font-weight: 500;
}

.modal-badge--cat {
  background: rgba(255,255,255,0.15);
  color: #ccc;
}

.modal-badge--acc {
  background: var(--primary);
  color: #fff;
}

/* ===============================
   🔚 Footer
================================= */
.footer {
  text-align: center;
  padding: 20px 0;
  color: #888;
  font-size: 14px;
}

/* ===============================
   🔥 Flop / Potential Lists
================================= */
.flop-item,
.region-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.region-item {
  align-items: flex-start;
}

.flop-left,
.category-left {
  display: flex;
  flex-direction: column;
}

.flop-title,
.region-name {
  font-weight: 600;
  color: #1f2937;
}

.flop-title.clickable {
  cursor: pointer;
}

.flop-title.clickable:hover {
  text-decoration: underline;
  color: #2563eb;
}

.flop-category,
.region-sub,
.category-sub {
  font-size: 13px;
  color: #6b7280;
  margin-top: 2px;
}

/* Badge-System */
.badge {
  min-width: 32px;
  padding: 6px 10px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 13px;
  text-align: center;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.1;
}

.badge-main {
  font-size: 14px;
  font-weight: 600;
}

.badge-sub {
  font-size: 12px;
  opacity: 0.8;
}

/* Farben */
.badge.danger {
  background: #fdecea;
  color: #d32f2f;
}

.badge.warning {
  background: #fff4e5;
  color: #f57c00;
}

.badge.neutral {
  background: #fff8e1;
  color: #f9a825;
}

.badge.success {
  background: #e6f4ea;
  color: #2e7d32;
}

.badge.gray {
  background: #dedede;
  color: #4a4a4a;
}

/* ===============================
   🌍 Region Layout
================================= */
.region-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.top-bar {
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.flop-meta {
  display: flex;
  justify-content: space-between;
}

/* ===============================
   🔍 Salon Suche
================================= */
.salon-search-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1.8fr auto;
  gap: 12px;
  align-items: center;
  margin-bottom: 16px;
}

.date-range {
  display: flex;
  align-items: center;
  gap: 6px;
}

.date-range input {
  flex: 1 1;
  min-width: 0;
}

.date-separator {
  color: var(--text-muted);
  font-size: 13px;
  flex-shrink: 0;
}

.btn-group {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.btn-group-spacer {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 7px;
  visibility: hidden;
}

.btn-group .btn-primary {
  padding: 7px 20px !important;
  margin-top: 0 !important;
  white-space: nowrap;
}

.btn-reset {
  padding: 8px 12px;
  background: #f5f5f5;
  color: #555;
  border: 1px solid #ccc;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
}

.no-result-hint {
  color: #999;
  font-size: 14px;
}

.salon-result-hint {
  font-size: 12px;
  color: var(--text-muted);
  margin-bottom: 8px;
}

.salon-result-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.salon-result-item {
  border: 1px solid var(--border-light);
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.salon-result-item--expanded {
  background: #f8f9fa;
}

.salon-result-header {
  display: grid;
  grid-template-columns: 120px 1fr 110px 110px;
  gap: 12px;
  padding: 10px 14px;
  cursor: pointer;
  align-items: center;
}

.salon-fiap-number {
  font-family: monospace;
  font-size: 13px;
  color: var(--secondary);
  font-weight: 600;
}

.salon-name {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-main);
}

.salon-closing {
  font-size: 12px;
  color: var(--text-muted);
  text-align: center;
}

.salon-expand-toggle {
  font-size: 12px;
  color: var(--text-muted);
  text-align: right;
}

.salon-detail {
  padding: 12px 14px 14px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 24px;
  font-size: 13px;
  border-top: 1px solid var(--border-light);
}

.salon-dates {
  grid-column: span 2;
  display: flex;
  gap: 24px;
  background: #f8f9fa;
  border-radius: 6px;
  padding: 8px 12px;
  flex-wrap: wrap;
}

.label-muted {
  color: var(--text-muted);
}

.span-2 {
  grid-column: span 2;
}

.image-rows-container {
  margin-bottom: 16px;
}

.image-rows-labels {
  display: flex;
  gap: 8px;
  margin-bottom: 7px;
}

.image-rows-labels span {
  font-size: 13px;
  font-weight: 600;
}

.image-rows-labels span:first-child,
.image-rows-labels span:nth-child(2) {
  flex: 1 1;
}

.image-rows-btn-placeholder {
  width: 32px;
  flex-shrink: 0;
}

.image-row {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  align-items: center;
}

.image-row > select {
  flex: 1 1;
  min-width: 0;
}

.image-row > input {
  flex: 1 1;
  min-width: 0;
  width: auto !important;
}

.btn-add-row {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 2px solid var(--primary);
  background: transparent;
  color: var(--primary);
  font-size: 22px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 2px 0;
  transition: background 0.15s, color 0.15s;
}

.btn-add-row:hover {
  background: var(--primary);
  color: #fff;
}

.card .btn-add-row {
  margin-top: 0;
  padding: 0;
}

.detail-indent {
  padding-left: 14px;
  margin-top: 2px;
}

.link-blue {
  color: var(--secondary);
}

/* ===============================
   📥 Import Grid
================================= */
.import-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 24px;
}

.import-grid--triple {
  grid-template-columns: 1fr 1fr 1fr;
}

/* ===============================
   📋 Import-Karten Header + Vorlage
================================= */
.import-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}

.import-card h2 {
  margin: 0;
}

.import-grid--triple .import-card h2 {
  font-size: 17px;
}

.btn-template-sm {
  display: inline-block;
  font-family: inherit;
  font-size: 12px;
  line-height: 1;
  color: var(--secondary);
  background: none;
  border: 1.5px solid var(--secondary);
  border-radius: 5px;
  padding: 4px 10px;
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.15s;
}

.btn-template-sm:hover {
  background: var(--secondary);
  color: #fff;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}

.checkbox-label input {
  width: auto;
  margin: 0;
}

.import-result-msg {
  margin-top: 8px;
  font-size: 13px;
  font-weight: 500;
}

.import-result-msg--success { color: var(--primary); }
.import-result-msg--error   { color: #d32f2f; }

.file-upload-btn--disabled {
  opacity: 0.6;
  pointer-events: none;
}

/* ===============================
   ✏️ Diverses
================================= */
.mb-24 { margin-bottom: 24px; }

.form-field--no-margin { margin: 0; }

.entry-card-title { margin: 0 0 20px 0; }

.form-hint {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 4px;
}

/* ===============================
   🔐 Login
================================= */
.login-overlay {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background: var(--bg);
}

.login-logo {
  width: 350px;
  object-fit: contain;
  display: block;
  margin: 0 auto 24px auto;
  border-radius: var(--radius);
}

.login-box {
  background: var(--card-bg);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 40px 36px;
  width: 100%;
  max-width: 380px;
}

.login-title {
  text-align: center;
  margin: 0 0 28px 0;
  font-size: 28px;
  color: var(--primary);
}

.login-footer {
  text-align: center;
  font-size: 11px;
  color: var(--text-muted);
  margin: 20px 0 0 0;
}

.login-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.login-form .form-field {
  width: 100%;
  text-align: center;
}

.login-form .form-field label {
  display: block;
  text-align: center;
}

.login-form .form-field input {
  text-align: center;
}

.login-error {
  color: #d32f2f;
  font-size: 13px;
  margin: 0;
  text-align: center;
}

.login-btn {
  padding: 9px 40px;
  font-size: 14px;
  width: auto;
}

/* ===============================
   👤 App-Header
================================= */
.app-header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.app-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: auto;
}

.app-header-user {
  font-size: 14px;
  color: var(--text-muted);
}

.header-logo {
  width: 100%;
  display: block;
  border-radius: var(--radius);
}

.app-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-self: end;
}

.app-header-actions .btn-primary {
  border: 2px solid transparent;
}

.app-header-user--clickable {
  cursor: pointer;
  border-radius: 6px;
  padding: 4px 8px;
  transition: background 0.15s;
}

.app-header-user--clickable:hover {
  background: var(--border-light);
  color: var(--text-main);
}

.btn-org {
  background: none;
  border: 1px solid var(--border-light);
  color: var(--text-muted);
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  padding: 3px 8px;
  border-radius: 6px;
  letter-spacing: 0.05em;
  transition: all 0.15s;
}
.btn-org:hover { border-color: var(--primary); color: var(--primary); }

.dvf-warning {
  background: #fff8e1;
  border: 1px solid #f9a825;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 13px;
  color: #5d4037;
  margin-bottom: 14px;
}
body.dark .dvf-warning {
  background: #2a2000;
  border-color: #f9a825;
  color: #ffd54f;
}

.btn-lang {
  background: none;
  border: 1px solid var(--border-light);
  color: var(--text-muted);
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 3px 8px;
  border-radius: 6px;
  letter-spacing: 0.05em;
  transition: all 0.15s;
}
.btn-lang:hover { border-color: var(--primary); color: var(--primary); }

.btn-darkmode {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 6px;
  line-height: 1;
  transition: background 0.15s;
}
.btn-darkmode:hover { background: var(--border-light); }

.btn-logout {
  background: #fff;
  border: 2px solid var(--secondary);
  color: var(--secondary);
  border-radius: 8px;
  padding: 5px 14px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-logout:hover {
  background: var(--secondary);
  color: #fff;
}

.btn-sm {
  padding: 5px 14px;
  font-size: 13px;
}

/* ===============================
   💬 Dialog
================================= */
.dialog-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.dialog-box {
  background: var(--card-bg);
  border-radius: var(--radius);
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  padding: 32px 36px;
  width: 100%;
  max-width: 400px;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.dialog-title {
  margin: 0;
  font-size: 18px;
  color: var(--text-main);
}

.dialog-close {
  background: none;
  border: none;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  color: var(--text-muted);
  padding: 0 4px;
}

.dialog-close:hover { color: var(--text-main); }

.dialog-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dialog-actions {
  display: flex;
  gap: 10px;
  margin-top: 4px;
}

.dialog-error {
  color: #d32f2f;
  font-size: 13px;
  margin: 0;
}

.dialog-success {
  color: var(--primary);
  font-size: 13px;
  margin: 0;
}

.dialog-box--wide {
  max-width: 520px;
}

.dialog-box--maintenance {
  max-width: 860px;
  min-height: 60vh;
  max-height: 85vh;
  overflow-y: auto;
}

.dialog-box--hint {
  max-width: 420px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 36px 32px;
}

.hint-icon {
  font-size: 36px;
}

.hint-text {
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: var(--text-main);
}

.hint-red {
  color: #d32f2f;
  font-weight: 600;
}

.dialog-divider {
  border: none;
  border-top: 1px solid var(--border-light);
  margin: 20px 0;
}

.dialog-section-title {
  font-weight: 600;
  font-size: 14px;
  margin: 0 0 12px 0;
  color: var(--text-main);
}

/* User-Liste */
.user-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.user-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: var(--bg);
  border-radius: 6px;
  gap: 12px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-name {
  font-weight: 500;
  font-size: 14px;
}

.user-role-badge {
  font-size: 12px;
  color: var(--text-muted);
}

.user-edit-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.user-edit-form input,
.user-edit-form select {
  padding: 7px 10px;
  border: 1px solid var(--border-light);
  border-radius: 6px;
  font-size: 13px;
  font-family: inherit;
  width: 100%;
  box-sizing: border-box;
}

.user-edit-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.user-delete-confirm {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.user-delete-warning {
  font-size: 13px;
  color: #d32f2f;
}

.btn-danger {
  padding: 5px 14px;
  font-size: 13px;
  background: #d32f2f;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.btn-danger:hover    { background: #b71c1c; }
.btn-danger:disabled { opacity: 0.6; cursor: not-allowed; }

/* Karten-Override: spezifische Klassen gewinnen gegen .card button */
.card .btn-danger    { background: #d32f2f; color: #fff; border: none; margin-top: 0; }
.card .btn-danger:hover { background: #b71c1c; }
.card .btn-warning   { background: #f57c00; color: #fff; border: none; margin-top: 0; }
.card .btn-warning:hover { background: #e65100; }
.card .btn-success   { background: #2e7d32; color: #fff; border: none; margin-top: 0; }
.card .btn-success:hover { background: #1b5e20; }
.card .btn-secondary { background: #fff; color: var(--secondary); border: 2px solid var(--secondary); margin-top: 0; }
.card .btn-secondary:hover { background: var(--secondary); color: #fff; }
.card .btn-primary   { background: var(--primary); color: #fff; border: none; margin-top: 0; }
.card .btn-primary:hover { background: var(--primary-dark); }

/* ===============================
   🗂 Tab-Navigation
================================= */
.tab-nav {
  display: flex;
  gap: 4px;
  border-bottom: 2px solid var(--border-light);
  margin-bottom: 24px;
}

.tab-btn {
  padding: 10px 22px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.15s;
}

.tab-btn:hover {
  color: var(--primary);
}

.tab-btn--active {
  color: var(--primary);
  border-bottom-color: var(--primary);
}

/* ===============================
   ⚙️ Admin-Tab
================================= */
.admin-tab {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.admin-section {
  padding: 24px 28px;
}

.admin-new-user-form {
  display: grid;
  grid-template-columns: 1fr 1fr auto auto;
  gap: 12px;
  align-items: end;
  margin-top: 4px;
}

.admin-new-user-form .btn-primary {
  padding: 7px 20px;
  margin-top: 0;
  white-space: nowrap;
}

.admin-upload-row {
  margin-top: 16px;
}

/* ===============================
   🖼️ Bildverwaltung
================================= */
.image-mgmt-hint {
  font-size: 13px;
  color: var(--text-muted);
  margin: 0 0 16px 0;
}

.image-mgmt-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.image-mgmt-row {
  display: grid;
  grid-template-columns: 72px 1fr auto;
  align-items: center;
  gap: 14px;
  padding: 10px 12px;
  background: var(--bg);
  border-radius: 6px;
}

.image-mgmt-thumb {
  width: 72px;
  height: 54px;
  border-radius: 5px;
  overflow: hidden;
  background: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.image-mgmt-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-mgmt-placeholder {
  font-size: 10px;
  color: var(--text-muted);
}

.image-mgmt-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.image-mgmt-title {
  font-weight: 500;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.image-mgmt-cat {
  font-size: 11px;
  color: var(--text-muted);
}

.image-mgmt-upload {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.image-mgmt-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.file-upload-btn--sm {
  padding: 6px 14px;
  font-size: 12px;
}

/* ===============================
   🔧 Datenpflege
================================= */
.maintenance-search {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 12px;
  align-items: end;
  margin-bottom: 16px;
}

.maintenance-search-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.maintenance-warning {
  background: #fff8e1;
  border: 1px solid #f9a825;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 13px;
  color: #5d4037;
  margin-bottom: 14px;
}

.maintenance-results {
  overflow-x: auto;
}

.maintenance-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.maintenance-table th {
  text-align: left;
  padding: 8px 10px;
  border-bottom: 2px solid var(--border-light);
  color: var(--text-muted);
  font-weight: 600;
  white-space: nowrap;
}

.maintenance-table td {
  padding: 8px 10px;
  border-bottom: 1px solid var(--border-light);
  vertical-align: middle;
}

.maintenance-table tr:last-child td {
  border-bottom: none;
}

.maintenance-row--confirm td {
  background: #fff3e0;
}

.session-filter {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 12px;
  align-items: end;
  margin-bottom: 16px;
}

.session-filter input[type="number"] {
  width: 80px;
}

.footer-link {
  color: var(--primary);
  text-decoration: none;
}
.footer-link:hover { text-decoration: underline; }

.session-active {
  color: #2e7d32;
  font-weight: 600;
  font-size: 12px;
}

.session-ip {
  font-size: 11px;
  color: var(--text-muted);
  font-family: monospace;
}

.maintenance-actions {
  display: flex;
  gap: 6px;
  justify-content: flex-end;
  white-space: nowrap;
}

.btn-warning {
  padding: 5px 14px;
  font-size: 13px;
  background: #f57c00;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}
.btn-warning:hover { background: #e65100; }

.btn-success {
  padding: 5px 14px;
  font-size: 13px;
  background: #2e7d32;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}
.btn-success:hover { background: #1b5e20; }

.user-name--inactive {
  opacity: 0.45;
  text-decoration: line-through;
}

.user-expires-badge {
  font-size: 11px;
  background: #e3f2fd;
  color: #1565c0;
  border-radius: 4px;
  padding: 1px 7px;
  font-weight: 500;
}

.user-expires-badge--expired {
  background: #ffebee;
  color: #c62828;
}

.user-inactive-badge {
  font-size: 10px;
  background: #f57c00;
  color: #fff;
  border-radius: 4px;
  padding: 1px 6px;
  font-weight: 600;
}

/* ===============================
   📱 Responsive
================================= */
@media (max-width: 900px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .import-grid--triple {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 768px) {
  .app {
    padding: 12px;
  }
  h1 {
    font-size: 20px;
  }
  .app-header {
    flex-wrap: wrap;
    gap: 8px;
  }
  .app-header-user--clickable {
    font-size: 13px;
  }
  .btn-sm, .btn-logout {
    font-size: 12px;
    padding: 4px 10px;
  }
  .import-grid,
  .import-grid--triple {
    grid-template-columns: 1fr;
  }
  .salon-search-grid {
    grid-template-columns: 1fr;
  }
  .date-range {
    flex-direction: column;
    gap: 6px;
  }
  .date-separator {
    display: none;
  }
  .entry-form-grid {
    grid-template-columns: 1fr;
  }
  .span-2 {
    grid-column: span 1;
  }
  .result-radio-group {
    flex-wrap: wrap;
    gap: 8px;
  }
  .button-row {
    flex-direction: column;
    gap: 8px;
  }
  .button-row button {
    width: 100%;
  }
  .grid {
    grid-template-columns: 1fr;
  }
  .top-bar {
    flex-wrap: wrap;
    gap: 6px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;mCAEmC;AACnC;EACE,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;;EAEpB,aAAa;EACb,kBAAkB;;EAElB,oBAAoB;EACpB,qBAAqB;;EAErB,uBAAuB;;EAEvB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;;EAEpB,aAAa;EACb,kBAAkB;;EAElB,oBAAoB;EACpB,qBAAqB;;EAErB,uBAAuB;;EAEvB,uCAAuC;AACzC;;AAEA;;mCAEmC;AACnC;EACE,SAAS;EACT,qBAAqB;EACrB,yCAAyC;EACzC,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,6DAA6D;EAC7D,iCAAiC;AACnC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;;;EAGE,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;;;;EAKE,wBAAwB;AAC1B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA,oEAAoE;AACpE;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;;AAGA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,WAAW;AACb;AACA,oCAAoC,mBAAmB,EAAE;;AAEzD,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,iCAAiC;EACjC,uBAAuB;AACzB;AACA,+BAA+B,4BAA4B,EAAE;AAC7D,qCAAqC,4BAA4B,EAAE,oCAAoC,EAAE;AACzG,sBAAsB,yBAAyB,EAAE,qCAAqC,EAAE;AACxF,wBAAwB,yBAAyB,EAAE,uBAAuB,EAAE;AAC5E,oCAAoC,yBAAyB,EAAE;AAC/D,qCAAqC,gCAAgC,EAAE,WAAW,EAAE;AACpF,8BAA8B,uBAAuB,EAAE;AACvD,6BAA6B,wBAAwB,EAAE;AACvD,iCAAiC,uBAAuB,EAAE;AAC1D,qCAAqC,qCAAqC,EAAE;AAC5E,oCAAoC,wBAAwB,EAAE;AAC9D,iCAAiC,wBAAwB,EAAE;AAC3D,6BAA6B,yBAAyB,EAAE;AACxD,oCAAoC,uBAAuB,EAAE;;AAE7D;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;mCAEmC;AACnC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;;mCAEmC;AACnC;EACE,6DAA6D;EAC7D,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;mCAEmC;AACnC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,WAAW;AACX;;EAEE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;AACxB;;AAEA,UAAU;AACV;;EAEE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,aAAa;AACf;AACA,qBAAqB,+BAA+B,EAAE;AACtD,wBAAwB,YAAY,EAAE,mBAAmB,EAAE;;AAE3D,oBAAoB;AACpB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,aAAa;AACf;AACA,uBAAuB,4BAA4B,EAAE,WAAW,EAAE;;AAElE;;mCAEmC;AACnC;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;;mCAEmC;AACnC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;;mCAEmC;AACnC;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;mCAEmC;AACnC;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;mCAEmC;AACnC;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;mCAEmC;;AAEnC;;mCAEmC;AACnC;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,WAAW;EACX,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;;mCAEmC;AACnC;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;;mCAEmC;AACnC;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;;EAGE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;mCAEmC;AACnC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;mCAEmC;AACnC;EACE,aAAa;EACb,yCAAyC;EACzC,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;mCAEmC;AACnC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;mCAEmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,8BAA8B,qBAAqB,EAAE;AACrD,8BAA8B,cAAc,EAAE;;AAE9C;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;mCAEmC;AACnC,SAAS,mBAAmB,EAAE;;AAE9B,yBAAyB,SAAS,EAAE;;AAEpC,oBAAoB,kBAAkB,EAAE;;AAExC;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;mCAEmC;AACnC;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;;mCAEmC;AACnC;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;AACA,iBAAiB,4BAA4B,EAAE,qBAAqB,EAAE;;AAEtE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;AACA,kBAAkB,4BAA4B,EAAE,qBAAqB,EAAE;;AAEvE;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,4BAA4B;AAC9B;AACA,sBAAsB,+BAA+B,EAAE;;AAEvD;EACE,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;mCAEmC;AACnC;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,cAAc;AAChB;;AAEA,sBAAsB,uBAAuB,EAAE;;AAE/C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,YAAY,EAAE,mBAAmB,EAAE;;AAE1D,qEAAqE;AACrE,uBAAuB,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE;AACtF,0BAA0B,mBAAmB,EAAE;AAC/C,uBAAuB,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE;AACtF,2BAA2B,mBAAmB,EAAE;AAChD,uBAAuB,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE;AACtF,2BAA2B,mBAAmB,EAAE;AAChD,uBAAuB,gBAAgB,EAAE,uBAAuB,EAAE,kCAAkC,EAAE,aAAa,EAAE;AACrH,6BAA6B,4BAA4B,EAAE,WAAW,EAAE;AACxE,uBAAuB,0BAA0B,EAAE,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE;AAC7F,2BAA2B,+BAA+B,EAAE;;AAE5D;;mCAEmC;AACnC;EACE,aAAa;EACb,QAAQ;EACR,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;;mCAEmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;mCAEmC;AACnC;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;mCAEmC;AACnC;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;EAC5C,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AACA,qBAAqB,0BAA0B,EAAE;;AAEjD;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,qBAAqB,mBAAmB,EAAE;;AAE1C;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,qBAAqB,mBAAmB,EAAE;;AAE1C;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;mCAEmC;AACnC;EACE;IACE,qCAAqC;EACvC;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,QAAQ;EACV;EACA;IACE,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,QAAQ;EACV;AACF","sourcesContent":["/* ===============================\n   🌍 Variablen\n================================= */\n:root {\n  --primary: #1F7FA6;\n  --primary-dark: #175f7a;\n  --secondary: #1F7FA6;\n\n  --bg: #f5f7fa;\n  --card-bg: #ffffff;\n\n  --text-main: #1f2937;\n  --text-muted: #6c757d;\n\n  --border-light: #e9ecef;\n\n  --radius: 10px;\n  --shadow: 0 4px 14px rgba(0, 0, 0, 0.06);\n}\n\nbody.dark {\n  --primary: #3aa0c8;\n  --primary-dark: #1F7FA6;\n  --secondary: #3aa0c8;\n\n  --bg: #0f1117;\n  --card-bg: #1a1d27;\n\n  --text-main: #f0f4f8;\n  --text-muted: #c8d4e0;\n\n  --border-light: #2d3148;\n\n  --shadow: 0 4px 14px rgba(0, 0, 0, 0.4);\n}\n\n/* ===============================\n   🌍 Grundlayout\n================================= */\nbody {\n  margin: 0;\n  background: var(--bg);\n  font-family: 'Poppins', Arial, sans-serif;\n  color: var(--text-main);\n  transition: background 0.2s, color 0.2s;\n}\n\nbody.dark .card {\n  background: linear-gradient(135deg, #1e2130 0%, #161926 100%);\n  border-color: var(--border-light);\n}\n\nbody.dark .import-card {\n  background: linear-gradient(135deg, #1e2130 0%, #161926 100%);\n}\n\nbody.dark input:not([type=\"radio\"]):not([type=\"checkbox\"]),\nbody.dark select,\nbody.dark textarea {\n  background: #0f1117;\n  color: var(--text-main);\n  border-color: var(--border-light);\n}\n\nbody.dark .user-list-item,\nbody.dark .maintenance-row--confirm td,\nbody.dark .image-mgmt-row {\n  background: #0f1117;\n}\n\nbody.dark .tab-nav {\n  border-bottom-color: var(--border-light);\n}\n\nbody.dark .file-upload-btn {\n  background: #1a1d27;\n}\n\nbody.dark .login-box,\nbody.dark .dialog-box {\n  background: #1a1d27;\n}\n\nbody.dark .login-overlay {\n  background: #0f1117;\n}\n\nbody.dark .flop-title,\nbody.dark .region-name,\nbody.dark .category-name {\n  color: var(--text-main);\n}\n\nbody.dark .flop-category,\nbody.dark .region-sub,\nbody.dark .category-sub,\nbody.dark .flop-meta,\nbody.dark .label-muted {\n  color: var(--text-muted);\n}\n\nbody.dark .flop-item,\nbody.dark .region-item,\nbody.dark .category-item {\n  border-bottom-color: var(--border-light);\n}\n\nbody.dark .category-count {\n  background: #1e3a4a;\n  color: #3aa0c8;\n}\n\nbody.dark .progress-bar {\n  background: #2d3148;\n}\n\nbody.dark .top-bar label,\nbody.dark .section-label,\nbody.dark .card p {\n  color: var(--text-muted);\n}\n\n/* Datumfelder: Textfarbe auf Placeholder-Grau, Kalender-Icon hell */\nbody.dark .date-range input[type=\"date\"] {\n  color: var(--text-muted) !important;\n  color-scheme: dark;\n}\n\n/* Salon-Suchergebnisse Dark Mode */\nbody.dark .salon-result-item {\n  background: #1e2130;\n}\nbody.dark .salon-result-item--expanded {\n  background: #252839;\n}\nbody.dark .salon-name {\n  color: var(--text-main);\n}\nbody.dark .salon-closing,\nbody.dark .salon-expand-toggle {\n  color: var(--text-muted);\n}\nbody.dark .salon-detail {\n  background: #252839;\n  color: var(--text-muted);\n}\n\n\n.card .search-clear-btn {\n  background: #fff;\n  border: 2px solid var(--secondary);\n  color: var(--secondary);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 5px 20px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  margin-top: 0;\n}\n.card .search-clear-btn:hover {\n  background: var(--primary-dark);\n  border-color: var(--primary-dark);\n  color: #fff;\n}\nbody.dark .card .search-clear-btn { background: #1a1d27; }\n\n/* react-select Dark Mode */\nbody.dark .rs__control {\n  background-color: #1e2130;\n  border-color: var(--border-light);\n  color: var(--text-main);\n}\nbody.dark .rs__control:hover { border-color: var(--primary); }\nbody.dark .rs__control--is-focused { border-color: var(--primary); box-shadow: 0 0 0 1px var(--primary); }\nbody.dark .rs__menu { background-color: #1e2130; border: 1px solid var(--border-light); }\nbody.dark .rs__option { background-color: #1e2130; color: var(--text-main); }\nbody.dark .rs__option--is-focused { background-color: #2d3148; }\nbody.dark .rs__option--is-selected { background-color: var(--primary); color: #fff; }\nbody.dark .rs__single-value { color: var(--text-main); }\nbody.dark .rs__placeholder { color: var(--text-muted); }\nbody.dark .rs__input-container { color: var(--text-main); }\nbody.dark .rs__indicator-separator { background-color: var(--border-light); }\nbody.dark .rs__dropdown-indicator { color: var(--text-muted); }\nbody.dark .rs__clear-indicator { color: var(--text-muted); }\nbody.dark .rs__multi-value { background-color: #2d3148; }\nbody.dark .rs__multi-value__label { color: var(--text-main); }\n\n.app {\n  padding: 30px;\n  max-width: 1100px;\n  margin: 0 auto;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.main-content {\n  flex: 1;\n}\n\nh1 {\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n/* ===============================\n   📦 Grid Layout\n================================= */\n.grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 22px;\n  margin-bottom: 30px;\n}\n\n/* ===============================\n   🪟 Karten\n================================= */\n.card {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border: 1px dashed #adb5bd;\n  border-radius: var(--radius);\n  padding: 24px 26px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.card h2 {\n  margin: 0 0 16px 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.card p {\n  margin: 12px 0 6px;\n  font-weight: 500;\n}\n\n.card ul {\n  padding-left: 18px;\n  margin: 0;\n}\n\n.card li {\n  margin-bottom: 6px;\n}\n\n.card label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* ===============================\n   📝 Formular\n================================= */\n.full-width {\n  grid-column: span 3;\n}\n\n.entry-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 14px 24px;\n  align-items: end;\n  margin-bottom: 16px;\n}\n\n.form-field p,\n.form-field > label:not(.radio-item) {\n  margin: 0 0 7px;\n  font-size: 13px;\n  font-weight: 600;\n  display: block;\n}\n\n/* Inputs */\n.card input:not([type=\"radio\"]):not([type=\"checkbox\"]),\n.card select {\n  width: 100%;\n  max-width: 100%;\n  padding: 7px 10px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n/* Fokus */\n.card input:not([type=\"radio\"]):not([type=\"checkbox\"]):focus,\n.card select:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(46, 125, 50, 0.15);\n}\n\n/* Section label */\n.section-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-main);\n  margin: 16px 0 8px;\n}\n\n/* Primär-Button */\n.btn-primary {\n  padding: 9px 20px;\n  background: var(--primary);\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n  margin-top: 0;\n}\n.btn-primary:hover { background: var(--primary-dark); }\n.btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }\n\n/* Sekundär-Button */\n.btn-secondary {\n  padding: 9px 20px;\n  background: #fff;\n  color: var(--secondary);\n  border: 2px solid var(--secondary);\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-top: 0;\n}\n.btn-secondary:hover { background: var(--secondary); color: #fff; }\n\n/* ===============================\n   🔘 Radio Buttons\n================================= */\n.radio-group {\n  display: flex;\n  gap: 24px;\n  margin-top: 10px;\n  flex-wrap: wrap;\n}\n\n.radio-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.radio-item input {\n  width: auto;\n  margin: 0;\n}\n\n/* ===============================\n   🔘 Buttons\n================================= */\n.card button {\n  margin-top: 15px;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 6px;\n  background-color: var(--primary);\n  color: white;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  transition: background 0.2s ease;\n}\n\n.card button:hover {\n  background-color: var(--primary-dark);\n}\n\n.button-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border-light);\n}\n\n/* ===============================\n   📊 Progress Bars\n================================= */\n.progress-bar {\n  width: 100%;\n  height: 10px;\n  background: #e0e0e0;\n  border-radius: 5px;\n  margin-bottom: 10px;\n  overflow: hidden;\n}\n\n.progress {\n  height: 100%;\n  background: var(--primary);\n  transition: width 0.6s ease;\n}\n\n/* ===============================\n   📊 Kategorien\n================================= */\n.category-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.category-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.category-item:last-child {\n  border-bottom: none;\n}\n\n.category-count {\n  font-weight: 600;\n  background: #e8f5e9;\n  color: var(--primary);\n  padding: 2px 8px;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n/* ===============================\n   📂 Import Card\n================================= */\n.import-card {\n  padding: 20px 24px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border: 1px dashed #adb5bd;\n  display: flex;\n  flex-direction: column;\n}\n\n.import-row {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 12px;\n}\n\n.import-action {\n  margin-top: auto;\n  padding-top: 16px;\n  display: flex;\n  justify-content: center;\n}\n\n.file-upload-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: #fff;\n  border: 2px solid var(--secondary);\n  border-radius: 8px;\n  color: var(--secondary);\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.file-upload-btn:hover {\n  background: var(--secondary);\n  color: #fff;\n}\n\n.file-upload-btn input[type=\"file\"] {\n  display: none;\n}\n\n/* ===============================\n   📱 Responsive\n================================= */\n\n/* ===============================\n   🖼 Bild-Modal\n================================= */\n.image-modal {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(6px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  animation: modal-fade-in 0.2s ease;\n}\n\n@keyframes modal-fade-in {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n.image-modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 90vw;\n  max-height: 90vh;\n  animation: modal-slide-up 0.22s ease;\n}\n\n@keyframes modal-slide-up {\n  from { transform: translateY(24px); opacity: 0; }\n  to   { transform: translateY(0);    opacity: 1; }\n}\n\n.image-modal-content img {\n  max-width: 100%;\n  max-height: 78vh;\n  border-radius: 10px 10px 0 0;\n  display: block;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.6);\n}\n\n.modal-close {\n  position: absolute;\n  top: -14px;\n  right: -14px;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #fff;\n  border: none;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.3);\n  color: #333;\n  z-index: 1;\n  transition: background 0.15s;\n}\n\n.modal-close:hover {\n  background: #f0f0f0;\n}\n\n.modal-info {\n  width: 100%;\n  background: #1a1a2e;\n  border-radius: 0 0 10px 10px;\n  padding: 14px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.6);\n}\n\n.modal-title {\n  color: #fff;\n  font-weight: 600;\n  font-size: 15px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.modal-meta {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.modal-badge {\n  font-size: 12px;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-weight: 500;\n}\n\n.modal-badge--cat {\n  background: rgba(255,255,255,0.15);\n  color: #ccc;\n}\n\n.modal-badge--acc {\n  background: var(--primary);\n  color: #fff;\n}\n\n/* ===============================\n   🔚 Footer\n================================= */\n.footer {\n  text-align: center;\n  padding: 20px 0;\n  color: #888;\n  font-size: 14px;\n}\n\n/* ===============================\n   🔥 Flop / Potential Lists\n================================= */\n.flop-item,\n.region-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.region-item {\n  align-items: flex-start;\n}\n\n.flop-left,\n.category-left {\n  display: flex;\n  flex-direction: column;\n}\n\n.flop-title,\n.region-name {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.flop-title.clickable {\n  cursor: pointer;\n}\n\n.flop-title.clickable:hover {\n  text-decoration: underline;\n  color: #2563eb;\n}\n\n.flop-category,\n.region-sub,\n.category-sub {\n  font-size: 13px;\n  color: #6b7280;\n  margin-top: 2px;\n}\n\n/* Badge-System */\n.badge {\n  min-width: 32px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-weight: 600;\n  font-size: 13px;\n  text-align: center;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  line-height: 1.1;\n}\n\n.badge-main {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.badge-sub {\n  font-size: 12px;\n  opacity: 0.8;\n}\n\n/* Farben */\n.badge.danger {\n  background: #fdecea;\n  color: #d32f2f;\n}\n\n.badge.warning {\n  background: #fff4e5;\n  color: #f57c00;\n}\n\n.badge.neutral {\n  background: #fff8e1;\n  color: #f9a825;\n}\n\n.badge.success {\n  background: #e6f4ea;\n  color: #2e7d32;\n}\n\n.badge.gray {\n  background: #dedede;\n  color: #4a4a4a;\n}\n\n/* ===============================\n   🌍 Region Layout\n================================= */\n.region-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.top-bar {\n  margin-bottom: 25px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.flop-meta {\n  display: flex;\n  justify-content: space-between;\n}\n\n/* ===============================\n   🔍 Salon Suche\n================================= */\n.salon-search-grid {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1.8fr auto;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.date-range {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.date-range input {\n  flex: 1;\n  min-width: 0;\n}\n\n.date-separator {\n  color: var(--text-muted);\n  font-size: 13px;\n  flex-shrink: 0;\n}\n\n.btn-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.btn-group-spacer {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 7px;\n  visibility: hidden;\n}\n\n.btn-group .btn-primary {\n  padding: 7px 20px !important;\n  margin-top: 0 !important;\n  white-space: nowrap;\n}\n\n.btn-reset {\n  padding: 8px 12px;\n  background: #f5f5f5;\n  color: #555;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.no-result-hint {\n  color: #999;\n  font-size: 14px;\n}\n\n.salon-result-hint {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-bottom: 8px;\n}\n\n.salon-result-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.salon-result-item {\n  border: 1px solid var(--border-light);\n  border-radius: 8px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.salon-result-item--expanded {\n  background: #f8f9fa;\n}\n\n.salon-result-header {\n  display: grid;\n  grid-template-columns: 120px 1fr 110px 110px;\n  gap: 12px;\n  padding: 10px 14px;\n  cursor: pointer;\n  align-items: center;\n}\n\n.salon-fiap-number {\n  font-family: monospace;\n  font-size: 13px;\n  color: var(--secondary);\n  font-weight: 600;\n}\n\n.salon-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-main);\n}\n\n.salon-closing {\n  font-size: 12px;\n  color: var(--text-muted);\n  text-align: center;\n}\n\n.salon-expand-toggle {\n  font-size: 12px;\n  color: var(--text-muted);\n  text-align: right;\n}\n\n.salon-detail {\n  padding: 12px 14px 14px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px 24px;\n  font-size: 13px;\n  border-top: 1px solid var(--border-light);\n}\n\n.salon-dates {\n  grid-column: span 2;\n  display: flex;\n  gap: 24px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  padding: 8px 12px;\n  flex-wrap: wrap;\n}\n\n.label-muted {\n  color: var(--text-muted);\n}\n\n.span-2 {\n  grid-column: span 2;\n}\n\n.image-rows-container {\n  margin-bottom: 16px;\n}\n\n.image-rows-labels {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 7px;\n}\n\n.image-rows-labels span {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.image-rows-labels span:first-child,\n.image-rows-labels span:nth-child(2) {\n  flex: 1;\n}\n\n.image-rows-btn-placeholder {\n  width: 32px;\n  flex-shrink: 0;\n}\n\n.image-row {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 8px;\n  align-items: center;\n}\n\n.image-row > select {\n  flex: 1;\n  min-width: 0;\n}\n\n.image-row > input {\n  flex: 1;\n  min-width: 0;\n  width: auto !important;\n}\n\n.btn-add-row {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  border: 2px solid var(--primary);\n  background: transparent;\n  color: var(--primary);\n  font-size: 22px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0 2px 0;\n  transition: background 0.15s, color 0.15s;\n}\n\n.btn-add-row:hover {\n  background: var(--primary);\n  color: #fff;\n}\n\n.card .btn-add-row {\n  margin-top: 0;\n  padding: 0;\n}\n\n.detail-indent {\n  padding-left: 14px;\n  margin-top: 2px;\n}\n\n.link-blue {\n  color: var(--secondary);\n}\n\n/* ===============================\n   📥 Import Grid\n================================= */\n.import-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.import-grid--triple {\n  grid-template-columns: 1fr 1fr 1fr;\n}\n\n/* ===============================\n   📋 Import-Karten Header + Vorlage\n================================= */\n.import-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.import-card h2 {\n  margin: 0;\n}\n\n.import-grid--triple .import-card h2 {\n  font-size: 17px;\n}\n\n.btn-template-sm {\n  display: inline-block;\n  font-family: inherit;\n  font-size: 12px;\n  line-height: 1;\n  color: var(--secondary);\n  background: none;\n  border: 1.5px solid var(--secondary);\n  border-radius: 5px;\n  padding: 4px 10px;\n  text-decoration: none;\n  white-space: nowrap;\n  flex-shrink: 0;\n  transition: all 0.15s;\n}\n\n.btn-template-sm:hover {\n  background: var(--secondary);\n  color: #fff;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 8px;\n  font-size: 13px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.checkbox-label input {\n  width: auto;\n  margin: 0;\n}\n\n.import-result-msg {\n  margin-top: 8px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.import-result-msg--success { color: var(--primary); }\n.import-result-msg--error   { color: #d32f2f; }\n\n.file-upload-btn--disabled {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n/* ===============================\n   ✏️ Diverses\n================================= */\n.mb-24 { margin-bottom: 24px; }\n\n.form-field--no-margin { margin: 0; }\n\n.entry-card-title { margin: 0 0 20px 0; }\n\n.form-hint {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-top: 4px;\n}\n\n/* ===============================\n   🔐 Login\n================================= */\n.login-overlay {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  background: var(--bg);\n}\n\n.login-logo {\n  width: 350px;\n  object-fit: contain;\n  display: block;\n  margin: 0 auto 24px auto;\n  border-radius: var(--radius);\n}\n\n.login-box {\n  background: var(--card-bg);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n  padding: 40px 36px;\n  width: 100%;\n  max-width: 380px;\n}\n\n.login-title {\n  text-align: center;\n  margin: 0 0 28px 0;\n  font-size: 28px;\n  color: var(--primary);\n}\n\n.login-footer {\n  text-align: center;\n  font-size: 11px;\n  color: var(--text-muted);\n  margin: 20px 0 0 0;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.login-form .form-field {\n  width: 100%;\n  text-align: center;\n}\n\n.login-form .form-field label {\n  display: block;\n  text-align: center;\n}\n\n.login-form .form-field input {\n  text-align: center;\n}\n\n.login-error {\n  color: #d32f2f;\n  font-size: 13px;\n  margin: 0;\n  text-align: center;\n}\n\n.login-btn {\n  padding: 9px 40px;\n  font-size: 14px;\n  width: auto;\n}\n\n/* ===============================\n   👤 App-Header\n================================= */\n.app-header {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.app-header-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-right: auto;\n}\n\n.app-header-user {\n  font-size: 14px;\n  color: var(--text-muted);\n}\n\n.header-logo {\n  width: 100%;\n  display: block;\n  border-radius: var(--radius);\n}\n\n.app-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-self: end;\n}\n\n.app-header-actions .btn-primary {\n  border: 2px solid transparent;\n}\n\n.app-header-user--clickable {\n  cursor: pointer;\n  border-radius: 6px;\n  padding: 4px 8px;\n  transition: background 0.15s;\n}\n\n.app-header-user--clickable:hover {\n  background: var(--border-light);\n  color: var(--text-main);\n}\n\n.btn-org {\n  background: none;\n  border: 1px solid var(--border-light);\n  color: var(--text-muted);\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  padding: 3px 8px;\n  border-radius: 6px;\n  letter-spacing: 0.05em;\n  transition: all 0.15s;\n}\n.btn-org:hover { border-color: var(--primary); color: var(--primary); }\n\n.dvf-warning {\n  background: #fff8e1;\n  border: 1px solid #f9a825;\n  border-radius: 6px;\n  padding: 10px 14px;\n  font-size: 13px;\n  color: #5d4037;\n  margin-bottom: 14px;\n}\nbody.dark .dvf-warning {\n  background: #2a2000;\n  border-color: #f9a825;\n  color: #ffd54f;\n}\n\n.btn-lang {\n  background: none;\n  border: 1px solid var(--border-light);\n  color: var(--text-muted);\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 3px 8px;\n  border-radius: 6px;\n  letter-spacing: 0.05em;\n  transition: all 0.15s;\n}\n.btn-lang:hover { border-color: var(--primary); color: var(--primary); }\n\n.btn-darkmode {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 4px 6px;\n  border-radius: 6px;\n  line-height: 1;\n  transition: background 0.15s;\n}\n.btn-darkmode:hover { background: var(--border-light); }\n\n.btn-logout {\n  background: #fff;\n  border: 2px solid var(--secondary);\n  color: var(--secondary);\n  border-radius: 8px;\n  padding: 5px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-logout:hover {\n  background: var(--secondary);\n  color: #fff;\n}\n\n.btn-sm {\n  padding: 5px 14px;\n  font-size: 13px;\n}\n\n/* ===============================\n   💬 Dialog\n================================= */\n.dialog-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.dialog-box {\n  background: var(--card-bg);\n  border-radius: var(--radius);\n  box-shadow: 0 8px 32px rgba(0,0,0,0.18);\n  padding: 32px 36px;\n  width: 100%;\n  max-width: 400px;\n}\n\n.dialog-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.dialog-title {\n  margin: 0;\n  font-size: 18px;\n  color: var(--text-main);\n}\n\n.dialog-close {\n  background: none;\n  border: none;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  color: var(--text-muted);\n  padding: 0 4px;\n}\n\n.dialog-close:hover { color: var(--text-main); }\n\n.dialog-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.dialog-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.dialog-error {\n  color: #d32f2f;\n  font-size: 13px;\n  margin: 0;\n}\n\n.dialog-success {\n  color: var(--primary);\n  font-size: 13px;\n  margin: 0;\n}\n\n.dialog-box--wide {\n  max-width: 520px;\n}\n\n.dialog-box--maintenance {\n  max-width: 860px;\n  min-height: 60vh;\n  max-height: 85vh;\n  overflow-y: auto;\n}\n\n.dialog-box--hint {\n  max-width: 420px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 36px 32px;\n}\n\n.hint-icon {\n  font-size: 36px;\n}\n\n.hint-text {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--text-main);\n}\n\n.hint-red {\n  color: #d32f2f;\n  font-weight: 600;\n}\n\n.dialog-divider {\n  border: none;\n  border-top: 1px solid var(--border-light);\n  margin: 20px 0;\n}\n\n.dialog-section-title {\n  font-weight: 600;\n  font-size: 14px;\n  margin: 0 0 12px 0;\n  color: var(--text-main);\n}\n\n/* User-Liste */\n.user-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.user-list-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  background: var(--bg);\n  border-radius: 6px;\n  gap: 12px;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.user-name {\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.user-role-badge {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.user-edit-form {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.user-edit-form input,\n.user-edit-form select {\n  padding: 7px 10px;\n  border: 1px solid var(--border-light);\n  border-radius: 6px;\n  font-size: 13px;\n  font-family: inherit;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.user-edit-actions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.user-delete-confirm {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.user-delete-warning {\n  font-size: 13px;\n  color: #d32f2f;\n}\n\n.btn-danger {\n  padding: 5px 14px;\n  font-size: 13px;\n  background: #d32f2f;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.btn-danger:hover    { background: #b71c1c; }\n.btn-danger:disabled { opacity: 0.6; cursor: not-allowed; }\n\n/* Karten-Override: spezifische Klassen gewinnen gegen .card button */\n.card .btn-danger    { background: #d32f2f; color: #fff; border: none; margin-top: 0; }\n.card .btn-danger:hover { background: #b71c1c; }\n.card .btn-warning   { background: #f57c00; color: #fff; border: none; margin-top: 0; }\n.card .btn-warning:hover { background: #e65100; }\n.card .btn-success   { background: #2e7d32; color: #fff; border: none; margin-top: 0; }\n.card .btn-success:hover { background: #1b5e20; }\n.card .btn-secondary { background: #fff; color: var(--secondary); border: 2px solid var(--secondary); margin-top: 0; }\n.card .btn-secondary:hover { background: var(--secondary); color: #fff; }\n.card .btn-primary   { background: var(--primary); color: #fff; border: none; margin-top: 0; }\n.card .btn-primary:hover { background: var(--primary-dark); }\n\n/* ===============================\n   🗂 Tab-Navigation\n================================= */\n.tab-nav {\n  display: flex;\n  gap: 4px;\n  border-bottom: 2px solid var(--border-light);\n  margin-bottom: 24px;\n}\n\n.tab-btn {\n  padding: 10px 22px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -2px;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.tab-btn:hover {\n  color: var(--primary);\n}\n\n.tab-btn--active {\n  color: var(--primary);\n  border-bottom-color: var(--primary);\n}\n\n/* ===============================\n   ⚙️ Admin-Tab\n================================= */\n.admin-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.admin-section {\n  padding: 24px 28px;\n}\n\n.admin-new-user-form {\n  display: grid;\n  grid-template-columns: 1fr 1fr auto auto;\n  gap: 12px;\n  align-items: end;\n  margin-top: 4px;\n}\n\n.admin-new-user-form .btn-primary {\n  padding: 7px 20px;\n  margin-top: 0;\n  white-space: nowrap;\n}\n\n.admin-upload-row {\n  margin-top: 16px;\n}\n\n/* ===============================\n   🖼️ Bildverwaltung\n================================= */\n.image-mgmt-hint {\n  font-size: 13px;\n  color: var(--text-muted);\n  margin: 0 0 16px 0;\n}\n\n.image-mgmt-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.image-mgmt-row {\n  display: grid;\n  grid-template-columns: 72px 1fr auto;\n  align-items: center;\n  gap: 14px;\n  padding: 10px 12px;\n  background: var(--bg);\n  border-radius: 6px;\n}\n\n.image-mgmt-thumb {\n  width: 72px;\n  height: 54px;\n  border-radius: 5px;\n  overflow: hidden;\n  background: #e9ecef;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.image-mgmt-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.image-mgmt-placeholder {\n  font-size: 10px;\n  color: var(--text-muted);\n}\n\n.image-mgmt-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.image-mgmt-title {\n  font-weight: 500;\n  font-size: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.image-mgmt-cat {\n  font-size: 11px;\n  color: var(--text-muted);\n}\n\n.image-mgmt-upload {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n}\n\n.image-mgmt-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.file-upload-btn--sm {\n  padding: 6px 14px;\n  font-size: 12px;\n}\n\n/* ===============================\n   🔧 Datenpflege\n================================= */\n.maintenance-search {\n  display: grid;\n  grid-template-columns: 1fr 1fr auto;\n  gap: 12px;\n  align-items: end;\n  margin-bottom: 16px;\n}\n\n.maintenance-search-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.maintenance-warning {\n  background: #fff8e1;\n  border: 1px solid #f9a825;\n  border-radius: 6px;\n  padding: 10px 14px;\n  font-size: 13px;\n  color: #5d4037;\n  margin-bottom: 14px;\n}\n\n.maintenance-results {\n  overflow-x: auto;\n}\n\n.maintenance-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.maintenance-table th {\n  text-align: left;\n  padding: 8px 10px;\n  border-bottom: 2px solid var(--border-light);\n  color: var(--text-muted);\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.maintenance-table td {\n  padding: 8px 10px;\n  border-bottom: 1px solid var(--border-light);\n  vertical-align: middle;\n}\n\n.maintenance-table tr:last-child td {\n  border-bottom: none;\n}\n\n.maintenance-row--confirm td {\n  background: #fff3e0;\n}\n\n.session-filter {\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  gap: 12px;\n  align-items: end;\n  margin-bottom: 16px;\n}\n\n.session-filter input[type=\"number\"] {\n  width: 80px;\n}\n\n.footer-link {\n  color: var(--primary);\n  text-decoration: none;\n}\n.footer-link:hover { text-decoration: underline; }\n\n.session-active {\n  color: #2e7d32;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.session-ip {\n  font-size: 11px;\n  color: var(--text-muted);\n  font-family: monospace;\n}\n\n.maintenance-actions {\n  display: flex;\n  gap: 6px;\n  justify-content: flex-end;\n  white-space: nowrap;\n}\n\n.btn-warning {\n  padding: 5px 14px;\n  font-size: 13px;\n  background: #f57c00;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.btn-warning:hover { background: #e65100; }\n\n.btn-success {\n  padding: 5px 14px;\n  font-size: 13px;\n  background: #2e7d32;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.btn-success:hover { background: #1b5e20; }\n\n.user-name--inactive {\n  opacity: 0.45;\n  text-decoration: line-through;\n}\n\n.user-expires-badge {\n  font-size: 11px;\n  background: #e3f2fd;\n  color: #1565c0;\n  border-radius: 4px;\n  padding: 1px 7px;\n  font-weight: 500;\n}\n\n.user-expires-badge--expired {\n  background: #ffebee;\n  color: #c62828;\n}\n\n.user-inactive-badge {\n  font-size: 10px;\n  background: #f57c00;\n  color: #fff;\n  border-radius: 4px;\n  padding: 1px 6px;\n  font-weight: 600;\n}\n\n/* ===============================\n   📱 Responsive\n================================= */\n@media (max-width: 900px) {\n  .grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .import-grid--triple {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .app {\n    padding: 12px;\n  }\n  h1 {\n    font-size: 20px;\n  }\n  .app-header {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n  .app-header-user--clickable {\n    font-size: 13px;\n  }\n  .btn-sm, .btn-logout {\n    font-size: 12px;\n    padding: 4px 10px;\n  }\n  .import-grid,\n  .import-grid--triple {\n    grid-template-columns: 1fr;\n  }\n  .salon-search-grid {\n    grid-template-columns: 1fr;\n  }\n  .date-range {\n    flex-direction: column;\n    gap: 6px;\n  }\n  .date-separator {\n    display: none;\n  }\n  .entry-form-grid {\n    grid-template-columns: 1fr;\n  }\n  .span-2 {\n    grid-column: span 1;\n  }\n  .result-radio-group {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n  .button-row {\n    flex-direction: column;\n    gap: 8px;\n  }\n  .button-row button {\n    width: 100%;\n  }\n  .grid {\n    grid-template-columns: 1fr;\n  }\n  .top-bar {\n    flex-wrap: wrap;\n    gap: 6px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
